import { Components, Theme } from '@mui/material/styles';

export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: {
      minHeight: '34px',
    },
    indicator: {
      display: 'none',
    },
  },
};
